import {
  type IndeedConnectOutcome,
  useIndeedConnectReturn,
} from './use-indeed-connect-return';

export function IndeedConnectReturn({
  onOutcome,
}: {
  onOutcome: (outcome: IndeedConnectOutcome) => void;
}) {
  useIndeedConnectReturn(onOutcome);
  return null;
}
